import { BonusCondition, CustomerBonusSettlement } from '@synergy/models';

import { PoolMath } from './pool-math';

export const getConditionMemberBonus = (
    actualBonus: number,
    customerBonusSettlement: CustomerBonusSettlement,
    condition?: BonusCondition | undefined
) => {
    const { customerBonusPayout, customerBonusBase, payout } = customerBonusSettlement;
    const supplierPayout = condition?.supplierPayout;

    return PoolMath.round(
        actualBonus * (customerBonusPayout ?? supplierPayout ?? PoolMath.round(customerBonusBase * payout))
    );
};
